import { createDebugger } from '@iotize/common/debug';

const prefix = '@iotize/tap/auth';

export const debug = createDebugger(prefix);
